// Material Kit 2 React Base Styles
import colors from "./colors";

// Material Kit 2 React Helper Functions
import pxToRem from "../functions/pxToRem";

const { grey } = colors;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  borderColor: grey[300],

  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs: pxToRem(1.6),
    sm: pxToRem(2),
    md: pxToRem(6),
    lg: pxToRem(8),
    xl: pxToRem(12),
    xxl: pxToRem(16),
    section: pxToRem(160),
  },
};
